// ────────────────────────────────────────────────────────────────────────
// Query key factories.
//
// Centralising key tuples here keeps invalidation reliable: a mutation
// that writes to `/api/conversations/:id/messages` invalidates
// `queryKeys.conversations.detail(id)` and `queryKeys.conversations.all`,
// and the strings never drift between caller and invalidator because
// both import from this file.
// ────────────────────────────────────────────────────────────────────────

export const queryKeys = {
  auth: {
    me: ["auth", "me"] as const,
  },
  conversations: {
    all: ["conversations"] as const,
    list: (search?: string) =>
      ["conversations", "list", (search ?? "").trim()] as const,
    detail: (id: string) => ["conversations", "detail", id] as const,
  },
  dashboard: {
    snapshot: ["dashboard", "snapshot"] as const,
  },
} as const;
